import { render } from "./RakutenHomeRotation.vue?vue&type=template&id=6536c172"
import script from "./RakutenHomeRotation.vue?vue&type=script&lang=js"
export * from "./RakutenHomeRotation.vue?vue&type=script&lang=js"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__